import { Route } from '@angular/router';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { PublicComponent } from './public.component';
import { ResetPasswordProcessComponent } from '@app/public/components/reset-password-process/reset-password-process.component';
import { ResetPasswordRequestComponent } from '@app/public/components/reset-password-request/reset-password-request.component';
import { RegisterSuccessComponent } from './sucess/register-success/register-success.component';
import { UserRegistrationComponent } from './components/user-registration/user-registration.component';
import { EmailSentComponent } from './sucess/email-sent/email-sent.component';
import { GeneralTermsOfUseComponent } from '@app/general-terms-of-use/general-terms-of-use.component';

export const publicRouting: Route = {
  path: '',
  component: PublicComponent,
  children: [
    {
      path: 'resetpasswordprocess/:token',
      component: ResetPasswordProcessComponent,
    },
    {
      path: 'public/resetpasswordprocess/:token',
      component: ResetPasswordProcessComponent,
    },
    {
      path: 'resetpasswordrequest',
      component: ResetPasswordRequestComponent,
    },
    {
      path: 'public/resetpasswordrequest',
      component: ResetPasswordRequestComponent,
    },
    {
      path: 'disclaimer',
      component: DisclaimerComponent,
    },
    {
      path: 'public/disclaimer',
      component: DisclaimerComponent,
    },
    {
      path: 'registersuccess',
      component: RegisterSuccessComponent,
    },
    {
      path: 'public/registersuccess',
      component: RegisterSuccessComponent,
    },
    {
      path: 'public/user/registrieren/:id',
      component: UserRegistrationComponent,
    },
    {
      path: 'public/user/registrieren',
      component: UserRegistrationComponent,
    },
    {
      path: 'public/emailsent',
      component: EmailSentComponent,
    },
    {
      path: 'emailsent',
      component: EmailSentComponent,
    },
    {
      path: 'general-terms-of-use',
      component: GeneralTermsOfUseComponent,
    },
  ],
};
